<template>
  <div>
    <el-dialog :title="isCheckLook ? '查看POI券' : '新增POI券'" :visible.sync="dialogVisible" :width="'1000px'"
      :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false" @close="closedFun">
      <div class="container" v-loading="boxLoading" element-loading-text="正在加载...">
        <div class="dialog-alert">
          <strong>说明：</strong>
          <p>
            1、POI券在市场价的基础上使用。
          </p>
          <p>2、使用优惠券购票产生的优惠差额，将由您自己承担。</p>
          <p>
            3、佣金计算：用户使用优惠券购票，平台先按平台折扣价作为用户支付价计算出您的原始佣金，再减去使用优惠券购票产生的优惠差额，得出您最终的佣金。
          </p>
          <p class="dialog-alert_grey">
            例：市场价100元，平台折扣价90元(比市场价优惠10元)，用户使用20元优惠券购票(比市场价优惠20元)，则您的佣金=按平台折扣价90元计算得出的您的原始佣金 - 优惠差额(20元-10元)。
          </p>
        </div>
        <couponsTemplate ref="couponsTemplateRef" :form="templateFrom" :couponPlatformType="activityType"
          :disabled="isCheckLook"></couponsTemplate>
        <el-form label-width="120px" style="margin-top: 20px; width: 100%" :model="form" ref="formRef" :rules="rules"
          :disabled="isCheckLook">
          <el-form-item label="优惠券名称" prop="name">
            <el-input v-model="form.name" maxlength="30" show-word-limit placeholder="30个字以内"
              style="width: 800px"></el-input>
          </el-form-item>
          <!--        <el-form-item-->
          <!--          label="可用影院"-->
          <!--          prop="cinemaStandardStr"-->
          <!--          class="cinemaStand-item"-->
          <!--        >-->
          <!--          <el-tooltip-->
          <!--            class="item"-->
          <!--            effect="dark"-->
          <!--            :content="form.cinemaStandardStr"-->
          <!--            placement="top-start"-->
          <!--            popper-class="tool-tipgz"-->
          <!--          >-->
          <!--            <el-input-->
          <!--              v-model="form.cinemaStandardStr"-->
          <!--              placeholder="请筛选影院"-->
          <!--              disabled-->
          <!--              style="width: 400px"-->
          <!--            ></el-input>-->
          <!--          </el-tooltip>-->
          <!--          <span type="warning" class="cinemaStandBtn" @click="cinemaStandBtn"-->
          <!--            >筛选影院</span-->
          <!--          >-->
          <!--        </el-form-item>-->
          <el-form-item label="库存" prop="stock">
            <el-input v-model="form.stock" style="width: 200px">
              <template slot="append">张</template>
            </el-input>
          </el-form-item>
          <!--        <el-form-item label="面值" prop="originalPriceBd">-->
          <!--          <el-input v-model="form.originalPriceBd" style="width: 200px">-->
          <!--            <template slot="append">元</template>-->
          <!--          </el-input>-->
          <!--        </el-form-item>-->
          <el-form-item label="售价" prop="sellPriceBd">
            <el-input v-model="form.sellPriceBd" style="width: 200px">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <!--        <el-form-item label="适用位置" prop="useCondition">-->
          <!--          <el-select v-model="form.useCondition" placeholder="请选择适用位置">-->
          <!--            <el-option v-for="item in useConditionList" :key="item.value" :label="item.label" :value="item.value" />-->
          <!--          </el-select>-->
          <!--          <span style="margin-left: 10px;">座</span>-->
          <!--        </el-form-item>-->

          <el-form-item label="售卖时间" prop="soldTime">
            <el-date-picker v-model="form.soldTime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" range-separator="至"
              :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions">
            </el-date-picker>
            <span>（售卖时间最低2天起）</span>
          </el-form-item>

          <el-form-item label="用户使用期限" prop="useDateType">
            <el-radio-group v-model="form.useDateType" style="display: flex;flex-direction: column;" v-removeAriaHidden
              @change="handelChangeTimeType">
              <div style="display: flex;align-items: center;margin-bottom: 15px;">
                <el-radio :label="1" style="width: 80px;">
                  固定时间
                </el-radio>
                <el-form-item prop="timeArr">
                  <el-date-picker v-model="form.timeArr" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                    type="daterange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" range-separator="至"
                    :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-form-item>

              </div>
              <div style="display: flex;align-items: center">
                <el-radio :label="2" style="width: 80px;">
                  相对时间
                </el-radio>
                <el-form-item prop="expireDate">
                  购买后
                  <el-input v-model="form.expireDate" placeholder="请输入天数"
                    style="width: 120px; margin-right: 10px;margin-left: 10px;">
                  </el-input>
                  天
                </el-form-item>
              </div>
            </el-radio-group>

          </el-form-item>
          <el-form-item label="头图" prop="headerPic">
            <div class="headerPic" v-if="form.headerPic">
              <img @click="dialogImagShow(form.headerPic)" style="width: 150px;height:150px;" :src="form.headerPic">
              <i v-if="!isCheckLook" @click="removePic" class="el-icon-error delete-pic"></i>
            </div>
            <el-upload
               v-else
               class="avatar-uploader"
               :action="action"
               :headers="headers"
               :show-file-list="false"
               :on-error="uploadError"
               :before-upload="beforeAvatarUpload"
               :http-request="uploadFile">
              <div class="uploader-box">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </el-upload>
            <div>(建议上传1:1尺寸)</div>
          </el-form-item>

          <el-form-item label="页面详情" prop="detailFileUrlsList">
            <div class="pic-container">
              <div v-if="form.detailFileUrlsList && form.detailFileUrlsList.length < 4 && !isCheckLook"
                v-loading="uploadLoading" element-loading-text="正在上传...">
                <el-upload class="avatar-uploader" :action="action" :headers="headers" :show-file-list="false"
                  :on-error="uploadError" :before-upload="beforeAvatarUpload" :http-request="uploadFileDetail" multiple>
                  <div class="uploader-box">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                </el-upload>
              </div>
              <div class="pic-box">
                <div class="headerPic" v-for="(item, index) in form.detailFileUrlsList" :key="index">
                  <img @click="dialogImagShow(item)" :src="item">
                  <i v-if="!isCheckLook" @click="removePicDetail(index)" class="el-icon-error delete-pic"></i>
                </div>
              </div>
              <span style="padding-top: 70px;">（最多上传4张）</span>
            </div>
          </el-form-item>

        </el-form>
        <div class="btns-coantainer">
          <el-button :loading="submitLoading" type="warning" @click="submit" v-if="!isCheckLook">确认</el-button>
          <el-button type="warning" plain @click="onCancel">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 筛选影院 -->
    <!--    <filter-cinema-->
    <!--      v-if="cinemaVisible"-->
    <!--      v-model="cinemaVisible"-->
    <!--      @selectCinema="selectCinema"-->
    <!--      :ids="form.cinemaClassifyId"-->
    <!--      :types="form.cinemaFilterType"-->
    <!--      :isDisable="isCheckLook"-->
    <!--      @close="cinemaVisible = false"-->
    <!--    />-->
    <el-dialog :visible.sync="dialogVisibleImg">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import filterCinema from "../../coupon/FilterCinema.vue";
import { deepClone } from '@/utils/tool.js'
import mini from "@/api/mini";
const MiniModel = new mini();
import moment from 'moment'
import couponsTemplate from '@/components/couponsTemplate.vue'
import { useCouponsTemplate, useSetTemplateFrom } from '@/components/useCouponsTemplate.js'
import {compareDates} from '@/utils/date'
import set from '@/javaApi/set'
const setModel = new set()


let defaultForm = {
  // cinemaStandardStr: "全部影院",
  // cinemaClassifyId:[], //选中的影院
  // cinemaFilterType: 0, //0:全部影院 1:指定影院分类

  name: "",
  stock: "", //库存
  // originalPriceBd: "", //面值
  sellPriceBd: "", //售价
  // useCondition: "", //适用位置
  timeArr: [], //可用时间
  headerPic: "", //头图
  soldTime: [], //售卖时间
  detailFileUrlsList:[],
  useDateType: 1,
  expireDate: ''
}
export default {
  components: { filterCinema, couponsTemplate },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() + 1 * 24 * 3600 * 1000 <= Date.now();
        },
      },
      uploadQueue:[],
      isUploading:false,
      uploadLoading: false,
      boxLoading: false,
      activityType: '80',
      templateFrom: useCouponsTemplate(),
      headers: {
        OPENTOKEN: localStorage.getItem('java-token')
      },
      type: '',
      action: process.env.VUE_APP_NEW_OPEN_URL + '/movie/open/upload/merchant',
      dialogVisibleImg: false,
      dialogImageUrl: "",
      isCheckLook: false,
      dialogVisible: false,
      submitLoading: false,
      rules: {
        headerPic: [
          {
            required: true,
            message: "请上传头图",
            trigger: ["blur", "change"],
          },
        ],
        detailFileUrlsList: [
          {
            required: true,
            message: "请上传页面详情",
            trigger: ["blur", "change"],
          },
        ],
        useDateType: [{ required: true, message: '请选择用户使用期限', trigger: 'change' }],
        name: [
          {
            required: true,
            message: "请输入优惠券名称",
            trigger: ["blur", "change"],
          },
        ],
        timeArr: [
          {
            required: true,
            message: "请选择用户使用期限",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              console.log(rule, value, "时间==");
              const now = new Date()
              if (value && value.length === 2) {
                const [start, end] = value
                console.log(start, end, 'start, end')
                if (new Date(end).getTime() < now.getTime()) {
                  callback(new Error("结束时间必须大于当前时间"));
                } else {
                  callback();
                }
              }
            },
          }
        ],
        soldTime: [
          {
            type: 'array',
            required: true,
            message: "请选择用户售卖时间",
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => {
              if(this.form.timeArr && this.form.timeArr.length) {
                const [startTime, endTime] = value;
                if(compareDates(startTime,this.form.timeArr[0]) === 1) {
                  return callback(new Error("开始时间必须小于于等于用户使用期限开始时间"));
                }
                if(compareDates(endTime,this.form.timeArr[1]) === 1) {
                  return callback(new Error("结束时间必须小于于等于用户使用期限结束时间"));
                }
                this.$refs.formRef.clearValidate(['timeArr'])
                return callback();
              }else{
                this.$refs.formRef.clearValidate(['timeArr'])
                return callback();
              }
              // const now = new Date()
              // if (value && value.length === 2) {
              //   const [start, end] = value
              //   console.log(start, end,'start, end')
              //   if(new Date(end).getTime() < now.getTime()) {
              //     callback(new Error("结束时间必须大于当前时间"));
              //   }else{
              //     callback();
              //   }
              // }
            },
            trigger: 'change'
          }
        ],
        stock: [
          {
            required: true,
            message: "请输入库存",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\+?[1-9]\d*$/.test(value)) {
                callback(new Error("请输入正整数"));
              } else if(value > 100000000){
                callback(new Error("库存不能超过100000000"));
              }else {
                callback();
              }
            },
          },
        ],
        originalPriceBd: [
          {
            required: true,
            message: "请输入面值",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\+?[1-9]\d*$/.test(value)) {
                callback(new Error("请输入正整数"));
              } else if (value > 999) {
                callback(new Error("不能超过999"));
              } else if (value < 9) {
                callback(new Error("请输入≥9的正数"));
              } else {
                callback();
              }
            },
          },
        ],
        sellPriceBd: [
          {
            required: true,
            message: "请输入售价",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^(?!0+(\.0+)?$)(\d+(\.\d{1,2})?)$/.test(value)) {
                callback(new Error("请输入正数，最多2位小数"));
              } else if (value > 9999.99) {
                callback(new Error("售价不能超过9999.99"));
              } else if (value < 9) {
                callback(new Error("请输入≥9的正数"));
              } else {
                callback();
              }
            },
          },
        ],
        useCondition: [
          {
            required: true,
            message: "请选择适用位置",
            trigger: ["blur", "change"],
          },
        ],
      },
      form: {
      },
      cinemaVisible: false, // 筛选影院
      useConditionList: [
        {
          label: "请选择",
          value: "",
        },
        {
          label: "1",
          value: 1,
        },
        {
          label: "2",
          value: 2,
        },
        {
          label: "3",
          value: 3,
        },
        {
          label: "4",
          value: 4,
        },
      ],
      row:null,
    };
  },
  methods: {
    async uploadFile(event) {
      console.log(event,'filefile===uploadFile')
      const file = event.file
      await this.upload(file)
    },
    handelChangeTimeType(val) {
      this.$set(this.form,'expireDate','')
      this.$set(this.form,'timeArr',[])
    },
    dialogImagShow(url) {
      this.dialogImageUrl = url;
      this.dialogVisibleImg = true;
    },
    removePic() {
      this.form.headerPic = ''
    },
    uploadError(err) {
      this.$message.error(err);
      console.log('err', err)
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file, "handleAvatarSuccess");
      if (res.code === 200) {
        this.form.headerPic = res.data
      } else {
        this.$message.error(res.message);
      }
    },


    beforeAvatarUpload(file) {
      console.log(file,'filefile')
      return new Promise((resolve, reject) => {
        const isJPG = /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(file.name);
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('只能上传图片!');
          return reject(false);
        }
        // if(this.form.detailFileUrlsList.length >= 4) {
        //   this.$message.error('页面详情图片不能超过4张!');
        //   return reject(false);
        // }
        if (!isLt2M) {
          this.$message.error('图片大小不能超过 2MB!');
          return reject(false);
        }
        resolve(true);
      });
    },
    // beforeAvatarUpload(file) {
    //   return new Promise((resolve, reject) => {
    //     const isJPG = /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(file.name);
    //     const isLt2M = file.size / 1024 / 1024 < 2;

    //     if (!isJPG) {
    //       this.$message.error('只能上传图片!');
    //       return reject(false);
    //     }
    //     if (!isLt2M) {
    //       this.$message.error('图片大小不能超过 2MB!');
    //       return reject(false);
    //     }
    //     resolve(true);
    //   });
    // },
    async submit() {
      try {
        this.$refs.formRef.validate()
        let data = await this.$refs.couponsTemplateRef.calibration()
        let templateParams = {
          ...data.templateData,
          appKey: localStorage.getItem("appKeyMini"),
          couponPlatformType: this.activityType,
        }

        if(this.form.soldTime) {
          const time0 = moment(this.form.soldTime[0])
          const time1 = moment(this.form.soldTime[1])
          const diffInMinutes = time1.diff(time0, 'minutes')
          // 判断是否超过 47 小时 59 分钟（即 2879 分钟）
          const isOver = diffInMinutes >= (47 * 60 + 59)
          if(!isOver) {
            this.$message.error('售卖时间最低2天起')
            return
          }
        }

        await this.$refs.formRef.validate((valid) => {
          if (valid) {
            templateParams.name = this.form.name
            let paramsData = {
              activityType: this.activityType,
              activityExtraVo: {
                totalStock: this.form.stock,
              },
              appKey: localStorage.getItem("appKeyMini"),
              sellPrice: Math.round(this.form.sellPriceBd * 100),
              vo: templateParams,
              name: this.form.name,
              startTime: this.form.timeArr[0],
              expireTime: this.form.timeArr[1],
              fileUrls: this.form.headerPic,
              soldStartTime: this.form.soldTime[0],
              soldEndTime: this.form.soldTime[1],
              expireDate: this.form.expireDate,
              useDateType: this.form.useDateType,
              detailFileUrls:this.form.detailFileUrlsList,
            }
            let appKeyMini = localStorage.getItem("appKeyMini");
            let params = deepClone(this.form)
            // 可发放时间
            params.startTime = params.timeArr[0]
            params.endTime = params.timeArr[1]
            delete params.timeArr
            if (params.cinemaFilterType == 1) {
              // 可用影院分类Id英文逗号分隔
              params.cinemaClassifyId = params.cinemaClassifyId.join(',')
              // 可用影院分类 名称
              params.cinemaClassifyName = params.cinemaStandardStr
              delete params.cinemaStandardStr
            } else if (params.cinemaFilterType == 0) {
              params.cinemaClassifyId = ''
              params.cinemaClassifyName = ''
              delete params.cinemaStandardStr
            }

            // return
            this.submitLoading = true

            let promiseSubmit = ''

            if(this.type === 'add') {
              promiseSubmit = MiniModel.couponActivitySave(paramsData)
            } else {
              promiseSubmit = MiniModel.couponActivityEdit({
                ...paramsData,
                id: this.row.id
              })
            }

            promiseSubmit.then(res => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message);
                this.$emit('updateDy')
                this.dialogVisible = false
              } else {
                this.$message.error(res.data.message || `${this.type === 'add' ? '创建' : '编辑'}优惠券报错`);
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            console.log("error submit!!");
          }
        });
      } catch (err) {
        console.log('校验失败222', err)
      }

    },

    async uploadFileDetail(event) {
      const file = event.file
      this.uploadQueue.push(file)
      this.$nextTick(() => this.processUploadQueue())
    },

    async processUploadQueue() {
      this.uploadLoading = true
      if (this.isUploading) return
      this.isUploading = true
      try {
        while (this.uploadQueue.length > 0) {
          const item = this.uploadQueue.shift() // 从队列头部取出并移除
          try {
            console.log(item,'itemitemitem===')
            const res = await this.upload(item,'detail')
          } catch (error) {
            console.error('上传失败项:', item.file.name, error)
            // 可选：将失败项重新加入队列或进行其他处理
          }
        }
      } finally {
        this.isUploading = false
        // 检查是否有新项在处理过程中加入
        if (this.uploadQueue.length > 0) {
          this.processUploadQueue()
        }else{
          this.uploadLoading = false
        }
      }
    },

    async upload(file,typeStr){
      const formData = new window.FormData()
      formData.append('file', file)
      const res = await setModel.uoloadFile2(formData)
      if(res.data.code !== 200) {
        this.$message.error(res.data.message);
        return
      }
      let url = res.data.data
      if(typeStr === 'detail') {
        if(this.form.detailFileUrlsList.length >= 4) {
          this.$message.error('页面详情图片不能超过4张!');
          this.uploadQueue = []
          this.isUploading = false
          return
        }
        this.form.detailFileUrlsList.push(url)
      }else{
        this.form.headerPic = url
      }
    },
    // 选中部分,子传父
    selectCinema(arr, type) {
      console.log(arr, type, '点击确定==子传父')
      this.form.cinemaFilterType = type
      this.form.cinemaClassifyId = arr.map((item) => item.id);
      console.log(this.form.cinemaClassifyId, ' this.form.cinemaClassifyId ')
      if (type) {
        this.form.cinemaStandardStr = arr
          .map((item) => item.name)
          .join(",");
      } else {
        this.form.cinemaStandardStr = '全部影院'
      }
      console.log(this.form.cinemaStandardStr, 'this.form.cinemaStandardStr')
    },
    onCancel() {
      this.closeReset();
    },
    async open(row, type) {
      this.form.detailFileUrlsList = []
      this.type = type;
      this.row = row
      if(type ==='view') {
        this.isCheckLook = true
      } else {
        this.isCheckLook = false
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.couponsTemplateRef.open()
      });
      if (row) {
        this.boxLoading = true
        const res = await MiniModel.couponActivityDetail({
          templateId: row.templateId,
          id: row.id,
        })
        this.boxLoading = false
        console.log(res, 'res==couTemplateDetail', res.data.code)
        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '获取详情失败')
          return
        }
        let data = res.data.data
        const { detailFileUrls, soldEndTime, soldStartTime } = data.vo.movieTemplateLimitJson;
        console.log(detailFileUrls,'detailFileUrlsdetailFileUrls')
        const detailFileUrlsList = detailFileUrls ? detailFileUrls.split(',') : [];
        this.form = {
          name: data.name,
          stock: data.activityExtraVo.totalStock, //库存
          // originalPrice: "", //面值
          sellPriceBd: data.sellPriceBd, //售价
          // useCondition: data, //适用位置
          headerPic: data.fileUrls, //头图
          soldTime: [soldStartTime, soldEndTime], //售卖时间
          useDateType: data.useDateType,
          detailFileUrlsList,
          couponPrice: data.couponPriceBd,
          floorAmount: data.floorAmountBd,
        }
        console.log('setTimeout')
        if(data.useDateType === 1) {
          this.$set(this.form,'timeArr',[data.startTime, data.expireTime])
        } else {
          this.$set(this.form,'expireDate',data.expireDate)
          this.$set(this.form,'timeArr',[])
        }
        this.$set(this.form,'useDateType',data.useDateType)


        this.templateFrom = useSetTemplateFrom(data.vo)
      } else {
        console.log('AAAAA===')
        this.form = Object.assign({}, defaultForm)
        this.form.detailFileUrlsList = []
        this.templateFrom = useCouponsTemplate()
        this.$nextTick(() => {
          this.$refs.couponsTemplateRef.resetForm()
        })
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      })
      console.log(this.form,'this.form')
    },
    handleClose() {
      console.log("右上角取消==1");
      this.closeReset();
    },
    closedFun() {
      console.log("关闭了");
    },
    closeReset() {
      this.dialogVisible = false;
    },
    cinemaStandBtn() {
      this.cinemaVisible = true;
    },
    changeTimesValue(e) {
      console.log(e, "可发放时间");
    },
    changeRadio(e, type) {
      console.log(e, type, "event");
      if (type == "a") {
        console.log("切换优惠券类型");
        // 优惠券类型
        if (e == 1) {
          this.form.discountNow = "";
        } else if (e == 2) {
          this.form.minPayAmount = "";
          this.form.discountAmount = "";
        }
      } else if (type == "b") {
        console.log("切换用户使用期限");
        // 用户使用期限
        if (e == 1) {
          this.form.useDay = "";
        } else if (e == 2) {
          this.form.useTimeArr = [];
        }
      }
    },
    removePicDetail(index) {
      this.form.detailFileUrlsList.splice(index, 1);
    },
  },
  watch:{
    'form.useDateType':{
      handler(newVal, oldVal) {
        console.log(newVal, oldVal, "useDateType====watch");
        if(newVal === 1) {
          this.$set(this.rules,'expireDate',[])
          this.$set(this.rules,'timeArr',[
            {
              required: true,
              message: "请选择用户使用期限",
              trigger: ["change"],
            },
            {
              required:true,validator: this.validatorTimeArr,trigger: 'change'
            }
          ])
          this.$nextTick(() => {
            // 清空表单校验
            if(this.$refs.formRef){
              this.$refs.formRef.clearValidate(['expireDate'])
            }
          })
        }else if(newVal === 2) {
          this.$set(this.rules,'timeArr',[])
          this.$set(this.rules,'expireDate',[
            {
              required: true,
              message: "请输入天数",
              trigger: 'change'
            },
            {
              pattern: /^\+?[1-9]\d*$/,
              message: "请输入正整数",
              trigger: ["blur", "change"],
            }
          ])
          this.$nextTick(() => {
            // 清空表单校验
            if(this.$refs.formRef){
              this.$refs.formRef.clearValidate(['timeArr'])
            }
          })
        }
        console.log(this.rules,'this.rulesthis.rules')
      },
      // immediate:true,
      deep: true
    },
  },
};
</script>

<style lang="less" scoped>
.btns-coantainer {
  margin: 30px 0 20px 120px;
}

.dialog-alert {
  display: block;
  padding: 10px;
  color: #666;
  background: #efefef;

  strong {
    display: block;
    color: #333;
  }

  p {
    display: block;
  }

  &_grey {
    color: #999;
  }
}

.cinemaStandBtn {
  margin-left: 20px;
  cursor: pointer;
  color: #ff8622;
  text-decoration: underline;
}

.type-container {
  display: flex;
  width: 450px;
  justify-content: space-between;
}

.status-text {
  color: #999;
  margin-left: 10px;
  font-size: 12px;
}

/deep/.el-range-separator {
  width: 10% !important;
}

/deep/.el-radio__input.is-checked+.el-radio__label {
  color: #333 !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #ff8622 !important;
  border-color: #ff8622 !important;
}

/deep/.el-date-editor,
.el-dialog__wrapper .el-date-editor {
  width: 400px !important;
}

.headerPic {
  width: 150px;
  height: 150px;
  background: #fff;
  position: relative;
  border: 1px solid #ccc;;

  img {
    width: 100%;
    height: 100%;
  }
}

.pic-box {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}


.delete-pic {
  position: absolute;
  top: -8px;
  right: -8px;
  color: #ff8622;
  font-size: 22px;
  cursor: pointer;
}

.uploader-box {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.avatar-uploader-icon {
  font-size: 30px;
}
</style>
<style>
.tool-tipgz {
  max-width: 600px;
}

.el-tooltip__popper {
  max-width: 60% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponDyPoiNew/component/createCoupon.vue